
export function isUrlEqual(url1, url2) {
  try {
    if (url1 === url2) {
      return true
    }

    if (decodeURIComponent(url1) === decodeURIComponent(url2)) {
      return true
    }

    return false
  } catch (error) {
    console.error(error)
    return false
  }
}

const SAME_PATE_TAG_DICT = {
  home: {
    literal: 'home',
    urls: [
      '/',
      '/s/erp',
      '/s/erp/',
      '/s/erp/#/',
      '/s/erp/#/home',
    ]
  },
  biHome: {
    literal: 'biHome',
    urls: [
      '/s/bi',
      '/s/bi/',
      '/s/bi/#/',
      '/s/bi/#/home',
    ]
  },
}

function getUrlPath2End(url) {
  try {
    const mid = url.split('/').slice(3).join('/')
    return '/' + mid
  } catch (error) {
    return ''
  }
}

function isInSameStrategyGroup(url1, url2) {
  const arr = Object.values(SAME_PATE_TAG_DICT)
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i]
    const urls = item.urls
    if (urls.includes(getUrlPath2End(url1)) && urls.includes(getUrlPath2End(url2))) {
      console.log(`base-app 两个 url 属于同一个策略组 url1: ${url1}, url2: ${url2}`)
      return true
    }
  }

  return false
}

function isEqualBeforeQuestion(url1, url2) {
  const url1BeforeQuestion = String(url1).split('?')[0]
  const url2BeforeQuestion = String(url2).split('?')[0]
  if (url1BeforeQuestion === url2BeforeQuestion) {
    return true
  }

  return false
}

/**
 * 同一个页签判断逻辑
 * @param {*} url1
 * @param {*} url2
 * @returns
 */
export function isSamePageTagByUrl(url1, url2, options = {}) {
  const { strictToEnd = false } = options

  // 严格相等
  if (isUrlEqual(url1, url2)) {
    return true
  }

  if (strictToEnd) {
    // url 严格相等

    // 排除掉灰度环境的影响, 排除掉 router mode 的影响
    // 判断 history  -> hash
    // 判断 erp 系统有灰度环境的情况
    // 下方两个 url 其实是同一个页面
    // https://kj.qizhishangke.com/s/erp/orders/manual_order_creation
    // https://kj.qizhishangke.com/s/erp/c/#/orders/manual_order_creation
    if (isEqualIgnoreGreyEnvAndRouterMode(url1, url2, { strict: true })) {
      return true
    }
  } else {
    // 在同一个策略组, 比如多个 url 对应的都是首页
    if (isInSameStrategyGroup(url1, url2)) {
      return true
    }

    // -? 前面的部分相等
    if (isEqualBeforeQuestion(url1, url2)) {
      return true
    }

    // 判断 history  -> hash
    // 判断 erp 系统有灰度环境的情况
    // 下方两个 url 其实是同一个页面
    // https://kj.qizhishangke.com/s/erp/orders/manual_order_creation
    // https://kj.qizhishangke.com/s/erp/c/#/orders/manual_order_creation
    if (isEqualIgnoreGreyEnvAndRouterMode(url1, url2)) {
      return true
    }
  }

  return false
}

function isEqualIgnoreGreyEnvAndRouterMode(url1, url2, options = {}) {
  // console.log('exe fun: isEqualIgnoreGreyEnvAndRouterMode')
  const { strict = false } = options

  // 下方两个 url 其实是同一个页面
  // https://kj.qizhishangke.com/s/erp/orders/manual_order_creation&k1=v1&k2=v2
  // https://kj.qizhishangke.com/s/erp/c/orders/manual_order_creation&k1=v1&k2=v2
  // https://kj.qizhishangke.com/s/erp/#/orders/manual_order_creation&k1=v1&k2=v2
  // https://kj.qizhishangke.com/s/erp/c/#/orders/manual_order_creation&k1=v1&k2=v2
  // 解析
  // .*?\/s\/(?<subappname>[a-z]+)(?:\/(?<subappenv>[a-z])(?=\/))?(?:\/#)?(?<subappurl>(?<subpath>[^?\n]*)(?<subappquery>[^\n]*))
  // https://kj.qizhishangke.com/s/erp/c/orders/manual_order_creation?k1=v1&k2=v2
  // 1 subappname erp
  // 2 subappenv  c
  // 3 subappurl  /orders/manual_order_creation?k1=v1&k2=v2
  // 4 subpath    /orders/manual_order_creation
  // 5 subappquery ?k1=v1&k2=v2

  const analyzeUrl = (url) => {
    const urlPat = /.*?\/s\/(?<subappname>[a-z]+)(?:\/(?<subappenv>[a-z])(?=\/))?(?:\/#)?(?<subappurl>(?<subpath>[^?\n]*)(?<subappquery>[^\n]*))/
    const exeRet = urlPat.exec(url)
    return exeRet
  }

  try {
    const ret1 = analyzeUrl(url1)
    const ret2 = analyzeUrl(url2)

    if (!ret1 || !ret2) {
      return false
    }

    if (strict) {
      return ret1[1] === ret2[1] && ret1[3] === ret2[3]
    } else {
      return ret1[1] === ret2[1] && ret1[4] === ret2[4]
    }
  } catch (err) {
    console.error(err)
    return false
  }
}
